import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

const StyledCard = styled.div`
  ${tw`relative px-8 py-12 rounded-3xl border border-white bg-white/90 backdrop-blur-xl min-w-52 md:min-w-96 shadow-2xl`};
  width: 384px;
  `;

interface Props {
  children?: ReactNode;
}

const Card: FC<Props> = ({ children }) => <StyledCard>{children}</StyledCard>;

export default Card;
